class NavigationHover {
    constructor() {
      this.init();
    }
  
    init() {
      // Check if navigation hover is enabled via theme settings
      const isHoverEnabled = window.navigationHoverEnabled || false;
      
      if (isHoverEnabled) {
        this.enableHoverNavigation();
      }
    }
  
    enableHoverNavigation() {
      // Add class to body to enable hover styles
      document.body.classList.add('navigation-hover-enabled');
      
      // Get all navigation menu items
      const menuItems = document.querySelectorAll('.header__inline-menu header-menu');
      
      menuItems.forEach(menuItem => {
        const details = menuItem.querySelector('details');
        const summary = menuItem.querySelector('summary');
        
        if (details && summary) {
          // Prevent default click behavior on summary
          summary.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          });
          
          // Add hover functionality
          menuItem.addEventListener('mouseenter', () => {
            // Open the menu by setting the open attribute
            details.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
          });
          
          menuItem.addEventListener('mouseleave', () => {
            // Close the menu by removing the open attribute
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }
  }
  
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new NavigationHover();
  });
  
  // Re-initialize when theme editor updates
  document.addEventListener('shopify:section:load', () => {
    new NavigationHover();
  }); 